exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-enter-active,\n.page-leave-active {\n  transition: opacity 0.3s, transform 0.3s;\n}\n.page-enter,\n.page-leave-to {\n  opacity: 0;\n  transform: translateY(5%);\n}\n#member_main {\n  margin-top: 70px;\n}", ""]);

// exports
